// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Source Sans 3', 'Source Sans 3 Fallback'","fontStyle":"normal"},"className":"__className_1fdbab","variable":"__variable_1fdbab"};